import { useEffect, useRef } from "react";

export function useCartWatcher(callback: () => void, interval = 1000) {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    let previousCart = JSON.stringify(window.helium.datastore.memory.cart);

    const checkForChanges = () => {
      const currentCart = JSON.stringify(window.helium.datastore.memory.cart);
      if (currentCart !== previousCart) {
        previousCart = currentCart;
        savedCallback.current();
      }
    };

    const id = setInterval(checkForChanges, interval);

    return () => clearInterval(id);
  }, [interval]);
}
